<template>
  <div class="dark:bg-[#24262B] light:bg-[#F6F7FA]">
    <HomeBanner class="mb-0 md:mb-10" />
    <div class="px-2 pb-10 gap-10 md:(px-1/10 pb-15 gap-15) grid">
      <div class="grid grid-cols-2 gap-2 md:(grid-cols-4 gap-5)">
        <template v-for="menu in menus">
          <HomeMenuCard :menu="menu" />
        </template>
      </div>
      <HomeGameCard />
      <HomeBanksCard />
      <HomeEventCard />
      <div />
    </div>
  </div>
</template>
<script setup>
import HomeBanner from '@/components/Banners/HomeBanner.vue'
import HomeMenuCard from '@/components/Cards/HomeMenuCard.vue'
import menu1 from '@/assets/home/menus/link-1.png'
import menu2 from '@/assets/home/menus/link-2.png'
import menu3 from '@/assets/home/menus/link-3.png'
import menu4 from '@/assets/home/menus/link-4.png'
import icon1 from '@/assets/home/menus/icon-1.svg'
import icon2 from '@/assets/home/menus/icon-2.svg'
import icon3 from '@/assets/home/menus/icon-3.svg'
import icon4 from '@/assets/home/menus/icon-4.svg'
import HomeBanksCard from '@/components/Cards/HomeBanksCard.vue'
import HomeEventCard from '@/components/Cards/HomeEventCard.vue'
import HomeGameCard from '@/components/Cards/HomeGameCard.vue'

const menus = [
  {
    icon: icon2,
    img: menu2,
    title: '스포츠',
    content: '축구, 야구, 농구, E스포츠 등 80개 이상 스포츠',
    route:{name: 'lives'},
    label: '스포츠 가기',
    color: 'from-[#1E7D3A] to-[#2CAE53]'
  },
  {
    icon: icon1,
    img: menu1,
    title: '카지노',
    content: '라이브 카지노 및 슬롯을 즐겨보세요',
    route:{name: 'casinos'},
    label: '카지노로 가기',
    color: 'from-[#5617CB] to-[#8447F6]'
  },
  {
    icon: icon3,
    img: menu3,
    title: '가상게임',
    content: 'bet365 가상스포츠 및 경주를 즐겨보세요',
    route:{name: 'virtual-games'},
    label: '가상게임 가기',
    color: 'from-[#CC6504] to-[#EB9C53]'
  },
  {
    icon: icon4,
    img: menu4,
    title: '파워볼',
    content: '당신의 행운의 숫자는 몇번일까요?',
    route:{name: 'mini-games'},
    label: '파워볼 가기',
    color: 'from-[#0858A6] to-[#377EE3]'
  },
]
</script>
